import { Pill } from "@src/appV2/redesign/system/ui-components";

interface CancellationStatusPillProps {
  readonly label: string;
}

/**
 * Compact pill displaying cancellation status on shift cards.
 * Positioned at the top-left of the card following the same pattern
 * as "Leave now" / "Urgent" pills on open shift cards.
 */
export function CancellationStatusPill({ label }: CancellationStatusPillProps) {
  return (
    <Pill
      size="small"
      label={label}
      backgroundColor={(theme) => theme.palette.grey[200]}
      color={(theme) => theme.palette.text.secondary}
      sx={{ width: "fit-content" }}
    />
  );
}
